import React, { Component } from 'react'
import {Link} from 'react-router-dom'
import menuItems from './menu-items'
import User from '../../container/user'

import { Sidebar, Menu, Icon, Container } from 'semantic-ui-react'

class AppBar extends Component {

  state = {
    visible: true
  }

  toggleVisibility(){
    this.setState({ visible: !this.state.visible })
  }

  render() {
    const { visible } = this.state
    function menuItemToHtml(menuItem){
      return (
        <div key={`lifeguides-menu-item-${menuItem.name}`}>
          <Link to={`${menuItem.to}`}>
            <Menu.Item style={{height: '100%'}} name={`${menuItem.name}`}>
              <div style={{marginTop: 15}}>
                {`${menuItem.label}`}
              </div>
            </Menu.Item>
          </Link>
        </div>
      );
    }

    let menuItemsHtml = menuItems.map(menuItemToHtml)

    return (
      <Sidebar
        as={Menu}
        animation='overlay'
        width='thin'
        direction='top'
        visible={visible}
        icon='labeled'>
        <Container>
          <Link to='/'>
            <img src = '/logo.png' style = {{height: 50, margin: '10px 0 8px 0', marginRight: 50}} />
          </Link>
          {menuItemsHtml}
          <Menu.Item position = 'right'>
            <User />
          </Menu.Item>
        </Container>
      </Sidebar>
    )
  }
}

export default AppBar



// WEBPACK FOOTER //
// ./src/components/ui/AppBar/index.js